export enum WorkItemType {
    Unknown = 'Unknown',
    Feature = 'Feature',
    ProductBacklogItem = 'Product Backlog Item',
    Bug = 'Bug'
}
